import React from "react";
import { HeartHandshake, Compass, Leaf, ShieldCheck, Sun, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Family Home Painting",
  description: "Transforming your family's living space with precision and care. We treat every home with the utmost respect, ensuring a clean workspace and a flawless finish that lasts for years.",
  icon: HeartHandshake,
  link: "/ServicesPage"
}, {
  title: "Luxury Coastal Villas",
  description: "Specialised painting services for high-end coastal properties. We use premium, weather-resistant materials designed to withstand the unique salt and sun conditions of the Central Coast.",
  icon: Sun,
  link: "/ServicesPage"
}, {
  title: "Interior Refresh",
  description: "Revitalise your interiors with our expert colour consultation and meticulous application. From feature walls to complete transformations, we deliver perfection in every brushstroke.",
  icon: Compass,
  link: "/ServicesPage"
}, {
  title: "Exterior Protection",
  description: "Protect your investment from the elements. Our comprehensive process includes thorough preparation and high-durability coatings for maximum curb appeal and long-term surface longevity.",
  icon: ShieldCheck,
  link: "/ServicesPage"
}, {
  title: "Eco-Friendly Solutions",
  description: "We prioritise your health and the environment by offering low-VOC and eco-friendly paint options. Enjoy a fresh new look without the harsh chemical odours or negative environmental impact.",
  icon: Leaf,
  link: "/ServicesPage"
}, {
  title: "Heritage & Decorative",
  description: "Expert restoration and decorative finishes for older homes and unique architectural features. Our 30+ years of experience ensures every detail is handled with professional local craftsmanship.",
  icon: Users,
  link: "/ServicesPage"
}];
export default function OurCounselingCoachingServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="6633" id="residential-painting-services" ref={ref} className="bg-background py-24 sm:py-32 relative overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <div className={`max-w-2xl mx-auto text-center mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-5xl font-sans font-bold text-primary mb-6 tracking-tight">
            Our Residential Painting Services
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            With over 30 years of local expertise, we provide Northern Central Coast homes with premium finishes and a commitment to cleanliness and respect.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-[${i * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <Card className="h-full bg-card border border-border shadow-sm hover:shadow-lg hover:border-accent hover:shadow-accent/10 transition-all duration-300 group flex flex-col">
                <CardHeader className="pb-4">
                  <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-full bg-muted/50 text-chart-2 group-hover:scale-110 transition-transform duration-300">
                    <service.icon className="w-6 h-6" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-2xl font-sans font-semibold text-primary group-hover:text-chart-2 transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="pt-4">
                  <Button asChild variant="outline" className="w-full border-border hover:border-accent hover:bg-accent/5 hover:text-primary transition-all font-sans font-semibold uppercase tracking-wider">
                    <Link to={service.link}>
                      View Details
                    </Link>
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}